export default __webpack_public_path__ + "static/media/slide5.462de8a1.jpg";